module.exports = __webpack_public_path__ + "static/06-83131f5080abae566c162f5c2f9c9b8f.jpg";